import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { 
  Box,
  useToast 
} from '@chakra-ui/react';
import { getFilmSynopsisData, updateFilmSynopsisData } from '../../../services/Films';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
// import SubmitButton from '../../../CommonComponents/SubmitButton';
import ImageWidget from '../../../CommonComponents/ImageWidget';
import { reverseTransformData, transformData } from '../../../util/helper';
import { RjsfSubmitButton } from '../../../RJSFCommonSchemas';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";


const Synopsis = () => {
  const { alias } = useParams();
  // const [basicFieldData, setBasicFieldData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [processedData, setProcessedData] = useState({});
  const [quickSave, setQuickSave] = useState(false);
  const toast = useToast();

  const schema =  {
    "title": "Film Synopsis fields",
    "description": "",
    "type": "object",
    "properties": {
      "synopsis": {
        "type": "string",
        "title": "Synopsis",
      },
      "synopsis_image_alias": {
        "type": "array",
        "title": "Synopsis Image Alias",
        "items": {
        "type": "object",
        "properties": {
          "image_alias": {
            "type": "string",
            "title": "Image Alias",
            "default":""
          },
          "image": {
            "type": "string",
            "title": "Image",
            "default":""
          },
        }
      }
      }
    }
  }

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
      "synopsis": {
        "ui:widget": "textarea",
        "ui:emptyValue": ""
      },
      // "synopsis_image_alias": {
      //   "ui:widget": "textarea"
      // },
      "synopsis_image_alias": {
        items: {
          image: {
            "ui:widget": ImageWidget, // Use the custom TypeaheadWidget
          },
        },
      }
    };

  const formData = processedData;

  // Fetch initial data
  useEffect(() => {
    const getPrefaceData = async () => {
      try {
        if (alias) {
          setIsLoading(true)
          const result = await getFilmSynopsisData(alias);
          if (result) {

            const fieldsToTransform = [
              'synopsis_image_alias'
            ];

            setProcessedData(transformData(result, fieldsToTransform));
            setQuickSave(false);
            // setBasicFieldData(result);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
                showErrorToast(toast, "Failed to fetch film data");
      } finally {
        setIsLoading(false);
      }
    };

    getPrefaceData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (formData) => {

    const fieldsToTransform = [
      'synopsis_image_alias'
    ];

    const updatedFormData = reverseTransformData(formData, fieldsToTransform);

    // setIsSubmitting(true);
    try {
      if (alias) {
        setIsSubmitting(true)
        const result = await updateFilmSynopsisData(alias, updatedFormData);

        if (result?.status === 200)
        {
          setQuickSave(prev => !prev);
                        showSuccessToast(toast, "Data updated successfully");
        }

        // Exit editing mode
        // setIsEditing(false);
      }
    } catch (error) {
      console.error('Error updating film data:', error);
            showErrorToast(toast, "Failed to update data");
    }
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="1200px">
      {isLoading ? (
        <FormLoader />
      ) : (
        <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={(e) => handleSubmit(e.formData)}>
          {/* <SubmitButton isLoading={isSubmitting}/> */}
        </Form>
      )}
    </Box>
  );
};

export default Synopsis;